import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import LoginRepository from '@/repositories/loginRepository';
import VendorRepository from '@/repositories/vendorRepository';
import cognitoRepository from '@/repositories/common/cognitoRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

// Utis
import utils from '@/commonProject/helpers/utils';

export const useLoginStore = defineStore({
    id: 'login',
    state: () => ({
        userId: '',
        nameKjLs: '',
        nameKjFs: '',
        vendorId: '',
        vendorType: '',
        maintenanceMode: false,
        userKeyNoSupport: false, //ユーザーキー番号
        userKeyNoNm: null, // ユーザーキー番号名称
        userM01Flag: false, // ログインユーザーの権限がユーザーでM01かどうか判定する。
        userM02Flag: false, // ログインユーザーの権限がユーザーでM02かどうか判定する。
        userM03Flag: false, // ログインユーザーの権限がユーザーでM03かどうか判定する。
        userM04Flag: false, // ログインユーザーの権限がユーザーでM04かどうか判定する。
        userM05Flag: false, // ログインユーザーの権限がユーザーでM05かどうか判定する。
        firstFlag: false, // VueでStoreを読み込ませるための任意要素。ログイン画面のonMoutnedでVueからStoreを読みだすためにのみ利用する。他の画面や機能では利用していない。
    }),
    getters: {
        getUserName() {
            return this.nameKjLs + ' ' + this.nameKjFs;
        },
        getVendorId() {
            return this.vendorId;
        },
        getVendorType() {
            return this.vendorType;
        },
        getMaintenanceMode() {
            return this.maintenanceMode;
        },
        getUserKeyNoSupport() {
            return this.userKeyNoSupport;
        },
        getUserKeyNoNm() {
            return this.userKeyNoNm;
        },
    },
    actions: {
        setVendorId(str) {
            this.vendorId = str;
        },

        setUserKeyNoSupport(str) {
            this.userKeyNoSupport = str;
        },

        setUserKeyNoNm(str) {
            this.userKeyNoNm = str;
        },
        reset() {
            this.userId = '';
            this.nameKjLs = '';
            this.nameKjFs = '';
            this.vendorId = '';
            this.vendorType = '';
            this.maintenanceMode = false;
            this.userKeyNoSupport = false;
            this.userKeyNoNm = null;
            this.userM01Flag = false; // ログインユーザーの権限がユーザーでM01かどうか判定する。
            this.userM02Flag = false; // ログインユーザーの権限がユーザーでM02かどうか判定する。
            this.userM03Flag = false; // ログインユーザーの権限がユーザーでM03かどうか判定する。
            this.userM04Flag = false; // ログインユーザーの権限がユーザーでM04かどうか判定する。
            this.userM05Flag = false; // ログインユーザーの権限がユーザーでM05かどうか判定する。
            this.firstFlag = false; // VueでStoreを読み込ませるための任意要素。ログイン画面のonMoutnedでVueからStoreを読みだすためにのみ利用する。他の画面や機能では利用していない。
        },

        /**
         * ログアウトAPI
         */
        logoutAction() {
            this.$reset();
        },

        /**
         * メンテナンス状態取得APIをコールする。
         * @param {Object} queryParam
         * @returns response
         */
        async getMaintenanceModeAction(API_URL, queryParam) {
            const loginRepository = new LoginRepository();
            try {
                const response = await loginRepository.getMaintenanceModeApi(API_URL, queryParam);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.maintenanceMode = response.data.Maintenance;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * ベンダー情報取得APIをコールする。
         * @param {Object} queryParam
         * @returns response
         */
        async getVendorInfoAction(API_URL, queryParam) {
            const vendorRepository = new VendorRepository();
            try {
                const response = await vendorRepository.getVendorApi(API_URL, queryParam);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * ユーザー情報取得APIをコールする。
         * @param {Object} queryParam
         * @returns response
         */
        async getLoginUserInfoAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const loginRepository = new LoginRepository();
            try {
                const response = await loginRepository.getLoginUserInfoApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.userId = response.data.UserId;
                this.nameKjLs = response.data.NameKjLs;
                this.nameKjFs = response.data.NameKjFs;
                this.vendorType = response.data.VendorType;
                this.userKeyNoSupport = response.data.UserKeyNoSupport;
                this.userKeyNoNm = response.data.UserKeyNoNm;

                // ログインユーザーのユーザー権限の配列を保持しているか判定する。
                if (!utils.isNullEmptyArray(response.data.AuthorityInfo)) {
                    // 権限情報
                    const authorityInfo = response.data.AuthorityInfo;

                    // ログインユーザーの権限がユーザーでM01かどうか判定する。
                    const m01 = authorityInfo.find((item) => item === 'M01');
                    if (!utils.isNullEmpty(m01)) {
                        this.userM01Flag = true;
                    }

                    // ログインユーザーの権限がユーザーでM02かどうか判定する。
                    const m02 = authorityInfo.find((item) => item === 'M02');
                    if (!utils.isNullEmpty(m02)) {
                        this.userM02Flag = true;
                    }

                    // ログインユーザーの権限がユーザーでM03かどうか判定する。
                    const m03 = authorityInfo.find((item) => item === 'M03');
                    if (!utils.isNullEmpty(m03)) {
                        this.userM03Flag = true;
                    }

                    // ログインユーザーの権限がユーザーでM04かどうか判定する。
                    const m04 = authorityInfo.find((item) => item === 'M04');
                    if (!utils.isNullEmpty(m04)) {
                        this.userM04Flag = true;
                    }

                    // ログインユーザーの権限がユーザーでM05かどうか判定する。
                    const m05 = authorityInfo.find((item) => item === 'M05');
                    if (!utils.isNullEmpty(m05)) {
                        this.userM05Flag = true;
                    }
                }

                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * ユーザー状態確認APIをコールする。
         * @param {Object} queryParam
         * @returns response
         */
        async getUserStatusByLoginAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const loginRepository = new LoginRepository();
            try {
                const response = await loginRepository.getUserStatusByLoginActionApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * ユーザーログイン完了APIをコールする。
         * @param {Object} requestBody
         * @returns response
         */
        async postUserLoginDateUpdateAction(API_URL, requestBody) {
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const loginRepository = new LoginRepository();
            try {
                // ユーザーログイン完了APIをコールする。
                const response = await loginRepository.postUserLoginDateUpdateApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * ユーザーパスワード更新完了APIをコールする。
         * @param {Object} requestBody
         * @returns response
         */
        async postUserLoginPasswordUpdateedDateUpdateAction(API_URL, requestBody) {
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const loginRepository = new LoginRepository();
            try {
                // ユーザーパスワード更新完了APIをコールする。
                const response = await loginRepository.postUserLoginPasswordUpdateedDateUpdateApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * cognitoログインAPI
         * @param {*} req
         * @returns response
         */
        async cognitoLoginAction(Username, Password) {
            //const cognitoRepository = new CognitoRepository();
            try {
                const response = await cognitoRepository.cognitoLoginApi(Username, Password);
                return response;
            } catch (e) {
                return e;
            }
        },

        /**
         * Cognito Id Tokenの有効期限の判定
         * @param {*} req
         * @returns response
         */
        async isTokenValid() {
            //const cognitoRepository = new CognitoRepository();
            const cognitoToken = await cognitoRepository.checkTokenExpiration();
            if (utils.isNull(cognitoToken)) {
                return false;
            } else {
                return true;
            }
        },

        /**
         * SSOログイン用。
         * Cognito Id Tokenの有効期限の判定
         * @param {*} req
         * @returns response
         */
        async isTokenValidCheckByCallApi() {
            //const cognitoRepository = new CognitoRepository();
            const cognitoToken = await cognitoRepository.checkTokenExpiratioByCallApi();
            if (utils.isNull(cognitoToken)) {
                return false;
            } else {
                return true;
            }
        },

        /**
         * Cognitoセッションを破棄し、ログアウトする。
         * @param なし
         * @returns なし
         */
        async cognitoLogoutAction() {
            //const cognitoRepository = new CognitoRepository();
            await cognitoRepository.logout();
        },

        /**
         * cognitoログインAPI
         * @param {*} req
         * @returns response
         */
        async cognitoTokenCallAction(code, redirectUrl) {
            try {
                const response = await cognitoRepository.token_call(code, redirectUrl);
                return response;
            } catch (e) {
                return e;
            }
        },

        /**
         * ha256アルゴリズムでhash値を取得
         * @returns hashHex
         */
        async sha256() {
            // 「年月日時分秒ミリ秒」を取得
            const currentDate = new Date();
            const date = currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-' + ('0' + currentDate.getDate()).slice(-2) + ' ' + ('0' + currentDate.getHours()).slice(-2) + ':' + ('0' + currentDate.getMinutes()).slice(-2) + ':' + ('0' + currentDate.getSeconds()).slice(-2) + '.' + currentDate.getMilliseconds();
            // UUIDを取得
            const uuid = self.crypto.randomUUID();
            // 文字列をUint8Arrayにエンコードする
            const encoder = new TextEncoder();
            const msgUint8 = encoder.encode(date + '_' + uuid);
            // エンコードされたメッセージのSHA-256ハッシュを計算する
            // ここでWeb Crypto APIを使用している
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
            // SHA-256ハッシュの計算結果(hashBuffer)はArrayBufferなので、
            // それをUint8Arrayに変換し、16進数の文字列に変換する
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
            // SHA-256ハッシュの16進数の文字列を返す
            return hashHex;
        },
    },
    persist: {
        //ローカルストレージに保存する場合
        storage: localStorage,
        // storage: sessionStorage
    },
});
